define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class NapService
     */
    function NapService(offerService) {
        var self = this;

        /**
         * Returns boolean according to NAP's rule for Extension till price or not
         * @param  {Object}  order
         * @return {Boolean}
         */
        self.isTillExtensionPrice = function isTillExtensionPrice(order) {
            return !order.contract.isScanupIncluded;
        };

        /**
         * Returns boolean according to NAP's rule for including Scanup or not in the tillPack
         * @param  {Boolean}  scanupOwned            customer already owns a specific contract for a scanup
         * @param  {Boolean}  additionalScanupWanted
         * @return {Boolean}
         */
        self.isScanupIncluded = function isScanupIncluded(scanupOwned, additionalScanupWanted) {
            return scanupOwned ? (!!additionalScanupWanted) : true;
        };

        // Till Pack
        /**
         * Returns NAP till pack description
         * @param  {Object}  order
         * @param  {Boolean} isMixed         is the tillpack has mixed tillTypes
         * @param  {Boolean} _isAlreadyATill internal controller variable used for older offers
         * @param  {string}  tillsType
         * @return {String}                  Full tillpack description
         */
        self.getTillPackDescription = function getTillPackDescription(order, isMixed, _isAlreadyATill, tillsType) {
            var packDescription;

            if (tillsType === 'BM') {
                packDescription =
                    "Terminal Bimedia caisse B Moov, dock de chargement, clavier.";
                if (order.contract.isScanupIncluded) {
                    packDescription += " 1 Scan'Up";
                }

                return packDescription;
            }
            if (tillsType === 'BM+') {
                packDescription =
                    "Terminal Bimedia caisse B Moov+, dock de chargement, clavier.";
                if (order.contract.isScanupIncluded) {
                    packDescription += " 1 Scan'Up";
                }

                return packDescription;
            }
            if (tillsType === 'BT+') {
                packDescription =
                    'Terminal Bimedia caisse B Touch+, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }
            if (tillsType === 'BS') {
                packDescription =
                    'Terminal Bimedia caisse B Smart, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }

            if (tillsType === 'BSW') {
                packDescription =
                    'Terminal Bimedia caisse B Swift, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }

            if (tillsType === 'BG') {
                packDescription =
                    'Terminal Bimedia caisse B Green, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }

            if (tillsType === 'BW') {
                packDescription =
                    'Terminal Bimedia caisse B Wide, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }

            if (tillsType === 'BC') {
                packDescription =
                    'Terminal Bimedia caisse B Compact, clavier et souris, Tiroir-caisse, Imprimante tickets de caisse, Scanner 2D, Onduleur, 1 Imprimante A4.';
                if (order.contract.isScanupIncluded) {
                    packDescription += ", 1 Scan'Up";
                }

                return packDescription;
            }
        };

        // Prices exceptions for some TPE options that are priced monthly
        var TPEOPTIONS_EXCEPTIONS = ['NRBIOIC'];

        /**
         * Check if a given option reference is among TPE options Exceptions
         * @return {Boolean}
         */
        self.isTpeOptionException = function isTpeOptionException(reference) {
            return TPEOPTIONS_EXCEPTIONS.indexOf(reference) !== -1;
        };

        return self;
    }

    NapService.$inject = ['offerService'];

    angular.module('app.bdc.common.napService', []).factory('napService', NapService);
});
